var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "grid-view" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMainList,
                expression: "showMainList"
              }
            ],
            staticClass: "main-content",
            attrs: { type: "primary" }
          },
          [
            _c(
              "quotation-client-search-bar",
              {
                attrs: { filter: _vm.filter },
                on: { advSearchItemResetCallBack: _vm.toAdvancedQuery }
              },
              [
                _c(
                  "template",
                  { slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "onView",
                          type: "primary",
                          disabled: !_vm.currentRow
                        },
                        on: {
                          click: function($event) {
                            return _vm.onView()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Pricing.View")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "onAdd", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onAdd()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _c("quotation-client-data-grid", {
              attrs: {
                "config-module": "227101",
                "grid-options": _vm.gridOptions,
                "row-data": _vm.rowData
              }
            })
          ],
          1
        ),
        _vm.quotationClientPopup.visible
          ? _c("quotation-client-popup", {
              attrs: {
                visible: _vm.quotationClientPopup.visible,
                "quotation-client": _vm.quotationClientPopup.price
              },
              on: {
                close: function($event) {
                  _vm.quotationClientPopup.visible = false
                },
                callback: _vm.onQuotationClientPopupClose
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }